module.exports = __webpack_public_path__ + "static/bg_top_team-4f9b7b5fd1de016ff5bbb545c17c7f82.png";